import { Tooltip } from '@odo/shared-ui';

const NO_REPLY_TOOLTIP = "The AI judged the patient's latest message doesn't need a reply";

export function NoReplyNeededPill() {
    return (
        <Tooltip content={NO_REPLY_TOOLTIP} focusable>
            <span className="inline-flex flex-shrink-0 items-center whitespace-nowrap rounded-full bg-violet-100 px-2 py-0.5 text-xs font-medium text-violet-700">
                No reply needed
            </span>
        </Tooltip>
    );
}
